import UsageDatapoint from 'owa-analytics/lib/datapoints/UsageDatapoint';
import { lazyLogDatapoint } from 'owa-analytics/lib/LazyAnalytics';
import popoutReadingPane from 'owa-popout/lib/utils/popout/popoutReadingPane';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import TxpSource from '../store/viewSchema/TxpSource';
import populateTxpDataPointObject from './telemetry/populateTxpDataPointObject';
import { TxpDatapoint } from 'txp-data';

/**
 * Pops out a window which shows the mail corresponding to this TXP event
 * @param item calendar event
 */
export function viewInMail(event: CalendarEvent) {
    popoutReadingPane('mail', event.ExtractionSourceId.Id);
}

/**
 * Logs the TXP datapoints
 */
export function logTxpDatapoint(
    txpDatapoint: TxpDatapoint,
    datapointName: string,
    source: TxpSource,
    cosmosOnlyData?: string
): void {
    // Adding source to datapoint object
    txpDatapoint = populateTxpDataPointObject(source.toString(), txpDatapoint);
    let datapoint = new UsageDatapoint(datapointName, txpDatapoint, { isCore: true });
    if (cosmosOnlyData) {
        datapoint.addCosmosOnlyData(cosmosOnlyData);
    }
    lazyLogDatapoint.importAndExecute(datapoint);
}
